"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ZoomOutAlternate: ['zoom-out-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.706,22.292l-7.682-7.681a9.019,9.019,0,1,0-1.414,1.414l7.682,7.681a1,1,0,1,0,1.414-1.414ZM2,9a7,7,0,1,1,7,7A7.008,7.008,0,0,1,2,9Z', 'M12.5,8h-7a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2Z']],
  ZoomIn1: ['zoom-in-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,20.591,19.2,16.377A10.51,10.51,0,1,0,16.372,19.2l4.214,4.214a2.027,2.027,0,0,0,2.828,0A2,2,0,0,0,23.414,20.591ZM10.5,2.005a8.5,8.5,0,1,1-8.5,8.5A8.51,8.51,0,0,1,10.5,2.005Z', 'M7,11.505H9.5v2.5a1,1,0,1,0,2,0v-2.5H14a1,1,0,0,0,0-2H11.5v-2.5a1,1,0,1,0-2,0v2.5H7a1,1,0,0,0,0,2Z']],
  ZoomIn: ['zoom-in', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,20.59l-5.077-5.077a10.019,10.019,0,1,0-2.828,2.828l5.077,5.077a2.023,2.023,0,0,0,2.828,0A2,2,0,0,0,23.414,20.59ZM10,1.754A8.25,8.25,0,1,1,1.75,10,8.26,8.26,0,0,1,10,1.754Z', 'M10,16.754A6.75,6.75,0,1,0,3.25,10,6.758,6.758,0,0,0,10,16.754ZM7,9H9V7a1,1,0,1,1,2,0V9h2a1,1,0,0,1,0,2H11v2a1,1,0,0,1-2,0V11H7A1,1,0,1,1,7,9Z']],
  ZoomInPage: ['zoom-in-page', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.242,18.827a6.523,6.523,0,1,0-1.414,1.414l3.465,3.465a1.014,1.014,0,0,0,1.414,0,1,1,0,0,0,0-1.414ZM15,10.5A4.5,4.5,0,1,1,10.5,15,4.505,4.505,0,0,1,15,10.5Z', 'M13,15.749h1.25V17a.75.75,0,0,0,1.5,0v-1.25H17a.75.75,0,0,0,0-1.5H15.75V13a.75.75,0,0,0-1.5,0v1.25H13a.75.75,0,0,0,0,1.5Z', 'M3.933,0H1.957A1.959,1.959,0,0,0,0,1.956V3.933a1,1,0,0,0,2,0L1.957,2H3.933a1,1,0,0,0,0-2Z', 'M3.933,22,2,22.042V20.066a1,1,0,0,0-2,0v1.976A1.959,1.959,0,0,0,1.957,24H3.933a1,1,0,0,0,0-2Z', 'M1,11.533a1,1,0,0,0,1-1V7.6a1,1,0,0,0-2,0v2.934A1,1,0,0,0,1,11.533Z', 'M1,17.4a1,1,0,0,0,1-1V13.466a1,1,0,0,0-2,0V16.4A1,1,0,0,0,1,17.4Z', 'M23,6.6a1,1,0,0,0-1,1v2.934a1,1,0,1,0,2,0V7.6A1,1,0,0,0,23,6.6Z', 'M7.6,2H10a1,1,0,0,0,0-2H7.6a1,1,0,0,0,0,2Z', 'M14,2h2.4a1,1,0,0,0,0-2H14a1,1,0,0,0,0,2Z', 'M20.067,2,22,1.956V3.933a1,1,0,0,0,2,0V1.956A1.959,1.959,0,0,0,22.043,0H20.067a1,1,0,0,0,0,2Z', 'M10.533,22H7.6a1,1,0,1,0,0,2h2.933a1,1,0,0,0,0-2Z']],
  ZoomOut: ['zoom-out', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,20.585l-5.077-5.077a10.019,10.019,0,1,0-2.828,2.828l5.077,5.077a2,2,0,1,0,2.828-2.828ZM10,1.749A8.25,8.25,0,1,1,1.75,10,8.259,8.259,0,0,1,10,1.749Z', 'M10,16.749A6.75,6.75,0,1,0,3.25,10,6.758,6.758,0,0,0,10,16.749ZM7,9h6a1,1,0,0,1,0,2H7A1,1,0,0,1,7,9Z']],
  ZoomINAlternate: ['zoom-in-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.706,22.3l-7.682-7.682a9.023,9.023,0,1,0-1.414,1.414l7.682,7.682a1.013,1.013,0,0,0,1.414,0A1,1,0,0,0,23.706,22.3ZM2,9a7,7,0,1,1,7,7A7.008,7.008,0,0,1,2,9Z', 'M12.5,8H10V5.5a1,1,0,0,0-2,0V8H5.5a1,1,0,0,0,0,2H8v2.5a1,1,0,1,0,2,0V10h2.5a1,1,0,0,0,0-2Z']],
  ZoomOut1: ['zoom-out-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,20.59,19.2,16.376A10.5,10.5,0,1,0,16.372,19.2l4.214,4.213a2.023,2.023,0,0,0,2.828,0A2,2,0,0,0,23.414,20.59ZM10.5,2A8.5,8.5,0,1,1,2,10.5,8.51,8.51,0,0,1,10.5,2Z', 'M7,11.5h7a1,1,0,0,0,0-2H7a1,1,0,1,0,0,2Z']],
  ZoomOutPage: ['zoom-out-page', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.242,18.827a6.523,6.523,0,1,0-1.414,1.414l3.465,3.465a1.012,1.012,0,0,0,1.414,0,1,1,0,0,0,0-1.414ZM15,10.5A4.5,4.5,0,1,1,10.5,15,4.505,4.505,0,0,1,15,10.5Z', 'M13,15.749h4a.75.75,0,0,0,0-1.5H13a.75.75,0,0,0,0,1.5Z', 'M3.933,0H1.957A1.959,1.959,0,0,0,0,1.956V3.933a1,1,0,0,0,2,0L1.957,2H3.933a1,1,0,0,0,0-2Z', 'M3.933,22,2,22.042V20.066a1,1,0,0,0-2,0v1.976A1.959,1.959,0,0,0,1.957,24H3.933a1,1,0,0,0,0-2Z', 'M1,11.533a1,1,0,0,0,1-1V7.6a1,1,0,0,0-2,0v2.934A1,1,0,0,0,1,11.533Z', 'M1,17.4a1,1,0,0,0,1-1V13.466a1,1,0,0,0-2,0V16.4A1,1,0,0,0,1,17.4Z', 'M23,6.6a1,1,0,0,0-1,1v2.934a1,1,0,1,0,2,0V7.6A1,1,0,0,0,23,6.6Z', 'M7.6,2H10a1,1,0,0,0,0-2H7.6a1,1,0,0,0,0,2Z', 'M14,2h2.4a1,1,0,0,0,0-2H14a1,1,0,0,0,0,2Z', 'M20.067,2,22,1.956V3.933a1,1,0,0,0,2,0V1.956A1.959,1.959,0,0,0,22.043,0H20.067a1,1,0,0,0,0,2Z', 'M10,22H7.6a1,1,0,1,0,0,2H10a1,1,0,0,0,0-2Z']]
};
exports["default"] = _default;